import { parseElementHtml } from './html';

function build({ marginSize, drawDebuggingElements }: { marginSize: number, drawDebuggingElements: boolean }) {
  const Class = {
    contentWrapper: 'tn-syos-seat-container-viewport__content-wrapper',
    transformOriginMarker: 'tn-syos-seat-container-viewport__transform-origin-marker',
    marginDisplay: 'tn-syos-seat-container-viewport__margin-display',
  };

  const transformOriginMarkerHtml = drawDebuggingElements
    ? `<div class="${Class.transformOriginMarker}"></div>`
    : '';

  const marginDisplayHtml = drawDebuggingElements
    ? `<div class="${Class.marginDisplay}" style="border-width: ${marginSize}px;"></div>`
    : '';

  const $el = parseElementHtml(`
    <div class="tn-syos-seat-container-viewport">
      ${transformOriginMarkerHtml}
      <div class="${Class.contentWrapper}"></div>
      ${marginDisplayHtml}
    </div>
  `) as HTMLElement;

  let originMarkerEl: HTMLElement | null = null;

  if (drawDebuggingElements) {
    originMarkerEl = $el.querySelector<HTMLElement>(`.${Class.transformOriginMarker}`);
  }

  return {
    el: $el,
    originMarkerEl,
    containerEl: $el.querySelector<HTMLElement>(`.${Class.contentWrapper}`)!,
  };
}

export default {
  build,
};
